import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

import { FeedMatch } from "../types/feed-match";

export function cn(...input: ClassValue[]) {
  return twMerge(clsx(input));
}

export type PokeVariant =
  | "mutual"
  | "otherUserPoked"
  | "currentUserPoked"
  | "none";
export function getPokeVariant(match: FeedMatch): PokeVariant {
  if (match.otherUserPokedAt && match.pokedAt) {
    return match.otherUserPokedAt > match.pokedAt
      ? "otherUserPoked"
      : "currentUserPoked";
  }

  if (match.otherUserPokedAt) {
    return "otherUserPoked";
  }

  if (match.pokedAt) {
    return "currentUserPoked";
  }

  return "none";
}

export function withMiddleEllipsis(text: string, length: number) {
  if (text.length <= length) {
    return text;
  }

  const half = Math.floor(length / 2);
  return `${text.slice(0, half)}...${text.slice(-half)}`;
}
